import React from 'react';
import { Sun } from 'lucide-react';

const ThemeSettings = () => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-1">
            Appearance
          </h3>
          <p className="text-sm text-gray-600">
            Theme settings for Athena
          </p>
        </div>
        <Sun className="w-6 h-6 text-yellow-500" />
      </div>

      {/* Current Theme */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <span className="text-blue-500" role="img" aria-label="Info">
            ℹ️
          </span>
          <div>
            <h5 className="font-medium text-blue-900 mb-1">
              Light Mode Active
            </h5>
            <p className="text-sm text-blue-800">
              Athena is currently using light mode. Dark mode will be available in a future update.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemeSettings;